import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { locale, setInLocalStorage } from '@trqk/utils';

import { TourCard } from '../../TourCard';
import { HASHES, PATHS } from '../../../../../../constants';

import iconUrl from '../../../../../../assets/svg/insights-empty-range.svg';
import grayIconUrl from '../../../../../../assets/svg/insights-empty-range-grayscale.svg';

/**
 * Displays the Negotiate Deals step of the Insights cards tour.
 */
export const NegotiateDeals = ({
    checked,
    step,
    localStorageKey,
}: TourCardInstanceProps): JSX.Element => {
    const body = (
        <div className="text-center">
            {locale.enUS.INSIGHTS.CARDS.STEP_5_NEGOTIATE_DEALS.BODY.PART_1}
            &nbsp;
            <Link
                className={cx('underline', {
                    'text-primary-500': !checked,
                    'text-tertiary-400': checked,
                })}
                to={({ search }) => ({
                    hash: HASHES.STATEMENTS.EARNINGS_AND_RANGES,
                    pathname: `${PATHS.STATEMENTS}/charts`,
                    search,
                    state: {
                        fromLink: true,
                    },
                })}
                onClick={(): void => {
                    if (localStorageKey) {
                        setInLocalStorage(localStorageKey, (): boolean => true);
                    }
                }}
            >
                {locale.enUS.INSIGHTS.CARDS.STEP_5_NEGOTIATE_DEALS.BODY.PART_2}
            </Link>
            &nbsp;
            {locale.enUS.INSIGHTS.CARDS.STEP_5_NEGOTIATE_DEALS.BODY.PART_3}
        </div>
    );

    return (
        <TourCard
            body={body}
            checked={checked}
            iconUrl={iconUrl}
            grayIconUrl={grayIconUrl}
            iconWidth={100}
            step={step}
            title={locale.enUS.INSIGHTS.CARDS.STEP_5_NEGOTIATE_DEALS.TITLE}
        />
    );
};
